import { useCallback } from "react";

import { Button } from "@/components/ui/button/button";
import Help from "@/components/ui/icon/help";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip/tooltip";

import { useDownloadCSV } from "./hooks";

import type { ViewData } from "../../../model/type";

type Props = {
	viewData: ViewData;
};

export const AboutForSearchResultTable = ({
	viewData: {
		searchResultTableData: { searchResultCountText, totalSalesAmountText, rows },
	},
}: Props) => {
	const { downloadSalesMastCSV } = useDownloadCSV();

	const handleClickDownloadCSVButton = useCallback(() => {
		downloadSalesMastCSV(rows);
	}, [downloadSalesMastCSV, rows]);

	return (
		<div className="flex items-center justify-between">
			<div className="grid grid-cols-1 items-center gap-4 tablet:flex">
				{/* 検索件数 */}
				<p>件数：{searchResultCountText}件</p>

				{/* 売り上げ合計 */}
				<p>売り上げ合計：{totalSalesAmountText}円</p>

				<Button type="button" variant={"outline"} size="sm" onClick={handleClickDownloadCSVButton}>
					CSVダウンロード
				</Button>
			</div>
			<div className="hidden items-center gap-x-2 text-sm tablet:flex">
				<p>予約手数料の算出方法</p>

				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger type="button" className="cursor-default">
							<Help size="sm" />
						</TooltipTrigger>
						<TooltipContent side="left" sideOffset={10}>
							<div className="flex flex-col gap-2 p-3">
								<p>予約手数料は</p>
								<div className="flex gap-1">
									<p>定額チケット適用対象</p>
									<p className="font-semibold text-brand">期間外</p>
									<p>の予約の場合は</p>
								</div>
								<p className="font-semibold">「従量課金（3%）+ カード決済手数料（約3%）」</p>
								<div className="flex gap-1">
									<p>定額チケット適用対象</p>
									<p className="font-semibold text-brand">期間内</p>
									<p>の予約の場合は</p>
								</div>
								<div className="flex">
									<p className="font-semibold">「定額課金（0%）+ カード決済手数料（約3%）」</p>
									<p>で算出されます。</p>
								</div>
								<div className="flex gap-1">
									<p>また、予約手数料は「決済確定日」ではなく</p>
									<p className="font-bold text-brand">「カード認証日」</p>
									<p>で計算されます。</p>
								</div>
								<p>
									繁忙期の予約が入り始める時期に、予約手数料を「定額課金」に切り替えることをお勧めします。
								</p>
							</div>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			</div>
		</div>
	);
};

AboutForSearchResultTable.displayName = "AboutForSearchResultTable";
